module.exports = __webpack_public_path__ + "img/Roka-ar-telefonu.2a272bc3.png";